import { useQuery } from 'react-query';

import { axios } from 'lib/axios';

const getCompanyPartnerTypes = async (companyId) => {
  const {
    data: { data: partnerTypes },
  } = await axios.get(`/api/companies/${companyId}/partner_types`);
  return partnerTypes;
};

export const useCompanyPartnerTypes = (companyId, queryOptions = {}) =>
  useQuery(['company-partner-types', companyId], () => getCompanyPartnerTypes(companyId), {
    initialData: [],
    enabled: !!companyId,
    ...queryOptions,
  });
